$(window).on("load",function(){
	$("body").removeClass("preload");
});

//スクロールアニメーション（フォントが読み込まれるまで待つ）
// $(window).on('load', function() {
//     // 全リソース読み込み完了後、少し待ってから初期化
//     setTimeout(function() {
//         $('.animate').scrolla({
// 			mobile: true, // モバイルの有効・無効
// 			once: true, // 発火は１度だけか、視界に入るたびに発火させるか
// 			animateCssVersion: 4 // used animate.css version (3 or 4)
//         });
//     }, 1000); // iPhone Safari用の待機時間
// });


$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/recruit/highschool/wp/wp-content/themes/miura-recruit/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

	$('.header_menu_content a').on('click', function () {
		body.removeClass('menu_open');
		// return false;
	});

    //閉じるボタン
    // $('.header_ac_close').on('click', function () {
    //     body.removeClass('menu_open');
    //     body.removeClass('search_open');
    // });

    //メニュー名以外の部分をクリックで閉じる
    $('.layer').on('click', function () {
        body.removeClass('menu_open');
        // body.removeClass('search_open');
    });

	//ヘッダードロップダウンメニュー
	$('.header_menu_gnav_trigger').on('click', function () {
		if($(this).hasClass('on')){
			// メニューを閉じる
			$(this).removeClass('on');
			$(this).next(".header_menu_gnav_dropdown").removeClass('on');
			body.removeClass('gnav-on'); // 閉じる時だけremove
		} else {
			// 他のメニューを閉じる
			$('.header_menu_gnav_trigger').removeClass('on');
			$('.header_menu_gnav_dropdown').removeClass('on');
			// クリックした要素を開く
			$(this).addClass('on');
			$(this).next(".header_menu_gnav_dropdown").addClass('on');
			body.addClass('gnav-on'); // 開く時だけadd
			// 看板アニメーション発火
			var $dropdown = $(this).next(".header_menu_gnav_dropdown");
			setTimeout(function() {
				$dropdown.find('.kanban-accordion').each(function() {
					// アニメーションをリセット
					$(this).removeClass('is-animated');
					// 強制的に再描画
					void $(this)[0].offsetWidth;
					// アニメーションクラス追加
					$(this).addClass('is-animated');
				});
			}, 50);
		}
	});

	//ページナビドロップダウンメニュー
    $('.pagenav_trigger').on('click', function () {
		if($(this).hasClass('on')){
			$(this).removeClass('on');
		} else {
			$(this).addClass('on');
		}
		$(this).next(".pagenav_dropdown").slideToggle();
		$(this).next(".pagenav_dropdown").toggleClass('on');
    });

	//アコーディオン
	$('.ac_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".ac_content").slideToggle();
	});

	//動画ポップアップ
    // $('.youtubeModal').modalVideo({channel: 'youtube'});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//タブ切り替え
    $(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parents().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parents().next().find(".tab_panel").eq($th).addClass("active");
	});

	// サブメニュー スクロール位置変更
	if($('.pagenav_ul').length){
		const activeElement = $(".pagenav_ul .active");
		
		if(activeElement.length){
			const headerNavBox = $(".pagenav_inner"); // .pagenav_innerに修正
			const targetElement = activeElement.closest('li');
			const targetLeft = targetElement.position().left;
			const targetWidth = targetElement.outerWidth();
			const containerWidth = headerNavBox.width();
			
			const scrollPosition = targetLeft - (containerWidth / 2) + (targetWidth / 2);
			
			headerNavBox.delay(1000).animate({scrollLeft: scrollPosition});
		}
	}

	// マジックフィックポップアップ
	$('.gallery-popup').each(function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			},
			image: {
    			titleSrc: 'data-caption'
  			}
		});
	});

	// インラインポップアップ
  	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false
  	});

  	//閉じるリンクの設定
  	$(document).on('click', '.popup-modal-dismiss', function (e) { 
    	e.preventDefault();
    	$.magnificPopup.close();
  	});

	//テキストアニメーション
	// document.querySelectorAll('.loop-txt').forEach(txt => {
	// 	txt.innerHTML += txt.innerHTML;
	// });

	// テキストアニメーション
	// document.querySelectorAll('.loop-txt').forEach(txt => {
	// 	// 画像をプリロード
	// 	const images = txt.querySelectorAll('img');
	// 	images.forEach(img => {
	// 		img.loading = 'eager';
	// 	});
		
	// 	txt.innerHTML += txt.innerHTML;
	// });

	// .swiper_imgsクラスを持つすべてのSwiperを初期化
	$('.swiper_imgs').each(function(index, element) {
		// 各Swiperに一意のクラスを追加
		$(element).addClass('swiper_imgs-' + index);
		// 各Swiper用のページネーションクラスも追加
		$(element).find('.swiper-pagination').addClass('swiper-pagination-' + index);
		// Swiperを初期化
		new Swiper('.swiper_imgs-' + index, {
			loop: true,                    // ループ有効
			autoplay: {
				delay: 3000,                 // 3秒ごとに自動スライド
				disableOnInteraction: false  // ユーザー操作後も自動再生継続
			},
			speed: 600,                    // スライド速度（ミリ秒）
			pagination: {
				el: '.swiper-pagination-' + index,
				clickable: true              // ページネーションクリック可能
			}
		});
	});

	//トップページ関連
	if($('.home').length){

		// ローディング
		const pageStartTime = performance.now();
		const loading = document.getElementById('loading');
		let loadingCompleted = false;
		let fvImagesLoaded = false;

		// カーテンオープン処理(重複実行を防ぐ)
		function openCurtain() {
			if (loadingCompleted) return;
			loadingCompleted = true;
			
			loading.classList.add('loaded');
			setTimeout(function() {
				loading.style.display = 'none';
				sessionStorage.setItem('loadingShown', 'true'); // テスト時コメントアウト
			}, 1000);
		}

		// 2回目以降はスキップ
		if (sessionStorage.getItem('loadingShown')) { // テスト時コメントアウト
			loading.style.display = 'none';
		} else {
			
			const animationDuration = 3300; // 丸ノコアニメーション時間
			
			// パターン1: FV周りの画像が読み込まれたかチェック
			const fvImages = document.querySelectorAll('.home_mv img');
			let loadedCount = 0;
			const totalImages = fvImages.length;
			
			fvImages.forEach(img => {
				if (img.complete) {
					loadedCount++;
				} else {
					img.addEventListener('load', function() {
						loadedCount++;
						checkFVLoaded();
					});
					img.addEventListener('error', function() {
						loadedCount++;
						checkFVLoaded();
					});
				}
			});
			
			function checkFVLoaded() {
				if (loadedCount >= totalImages) {
					fvImagesLoaded = true;
					tryOpenCurtain();
				}
			}
			
			// アニメーション終了時刻を計算
			const animationEndTime = pageStartTime + animationDuration;
			
			function tryOpenCurtain() {
				const currentTime = performance.now();
				const timeUntilAnimationEnd = animationEndTime - currentTime;
				
				// アニメーションが終わるまで待つ
				if (timeUntilAnimationEnd > 0) {
					setTimeout(openCurtain, timeUntilAnimationEnd);
				} else {
					openCurtain();
				}
			}
			
			// 初回チェック
			checkFVLoaded();
			
			// パターン2: 最大10秒で強制オープン
			setTimeout(function() {
				if (!loadingCompleted) {
					console.log('タイムアウトによる強制オープン');
					openCurtain();
				}
			}, 10000); // 10秒
		} // テスト時コメントアウト

		// // メインビジュアルが隠れたら
		// var scroll;
		// var objH = $('.home_mv').outerHeight();
		// var objTop = $('.home_mv').offset().top;
		// var objBottom = objTop + objH;
		// $(window).on('scroll', function(){
		//   	scroll = $(window).scrollTop();
		//   	if(scroll >= objBottom){
		//     	// 特定の要素を超えた
		//     	// console.log("超えた");
		// 		body.addClass("mvOut");
		//   	} else {
		// 		// 特定の要素を超えていない
		// 		// console.log("超えていない");
		// 		body.removeClass('mvOut');
		// 	}
		// });
	}

	// スライドを複製して無限ループ
	// const track = document.querySelector('.home_mv_slider_track');
	// if (track) {
	// 	const items = Array.from(track.children);
	// 	items.forEach(item => {
	// 		const clone = item.cloneNode(true);
	// 		track.appendChild(clone);
	// 	});
	// }

    // ニュースティッカー
    const home_mv_news_swiper = new Swiper('.home_mv_news_swiper', {
        // 基本設定
        direction: 'vertical', // 縦方向のスクロール
        loop: true,
        // slidesPerView: 1, // または数値で表示件数指定（例：3）
        // spaceBetween: 10, // スライド間の余白
        // 自動再生設定
        autoplay: {
            delay: 3000, // 3秒間隔で次のスライドへ
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        // スピード設定（スライド切り替えの速度）
        speed: 800,
        // 縦ティッカー用の設定
        grabCursor: false,
        allowTouchMove: false, // タッチ操作無効
        // 高さの設定（CSSでも可能）
        // height: 50, // ティッカーの高さ
        // ブレークポイント対応
        // breakpoints: {
        //     769: {
        //         direction: 'vertical',
        //     }
        // }
    });

	// インタビュースライド
	const home_interview_swiper = new Swiper('.home_interview_swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		loop: true,
		// loopedSlides: 12,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		// ブレークポイント対応
        breakpoints: {
            769: {
                spaceBetween: 50,
            }
        },
		on: {
			init: function() {
				const realSlides = document.querySelectorAll('.home_interview_swiper .swiper-slide:not(.swiper-slide-duplicate)');
				realSlides.forEach((slide, index) => {
					const num = String(index + 1).padStart(2, '0');
					const block = slide.querySelector('.interview-block');
					if (block) {
						block.setAttribute('data-number', num);
					}
				});
				const duplicates = document.querySelectorAll('.home_interview_swiper .swiper-slide-duplicate');
				duplicates.forEach(duplicate => {
					const original = duplicate.getAttribute('data-swiper-slide-index');
					const num = String(parseInt(original) + 1).padStart(2, '0');
					const block = duplicate.querySelector('.interview-block');
					if (block) {
						block.setAttribute('data-number', num);
					}
				});
			}
		}
	});

	// よくあるご質問アコーディオン
	$('.faqlist .ttl').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".txts").slideToggle();
	});  

	// カウントアップ関数
	function countUpNumber($element) {
		// console.log('カウントアップ開始');
		const targetNumber = parseInt($element.data('target'));
		// console.log('目標値:', targetNumber);
		const duration = 1000;
		const startTime = Date.now();
		
		function update() {
			const elapsed = Date.now() - startTime;
			const progress = Math.min(elapsed / duration, 1);
			
			const currentNumber = Math.floor(targetNumber * progress);
			$element.text(currentNumber);
			
			if (progress < 1) {
				requestAnimationFrame(update);
			} else {
				$element.text(targetNumber);
			}
		}
		
		requestAnimationFrame(update);
	}

	// グラフアニメーション関数（シンプル版）
	function animateGraph($graphImg) {
		// console.log('グラフアニメーション開始');
		const $graphTxt = $graphImg.siblings('.graph-txt');
		const $graphComments = $graphImg.parent('.graph').siblings('.data-comments'); // ★修正
		
		// CSSアニメーションを開始
		$graphImg.addClass('graph-animate');
		
		// 0.4秒後（80%の時点）でテキストをフェードイン
		setTimeout(function() {
			$graphTxt.addClass('show');
		}, 400);

		setTimeout(function() {
			$graphComments.addClass('show');
		}, 600);
	}

	// 実行
	$(document).ready(function() {
		// console.log('スクリプト読み込み完了');
		
		// 既にanimate__animatedが付いている要素を実行
		$('.animate__animated').each(function() {
			const $this = $(this);
			
			// カウントアップ
			$this.find('.number').each(function() {
				const $number = $(this);
				if (!$number.hasClass('counted')) {
					// console.log('初期実行: カウント');
					$number.addClass('counted');
					countUpNumber($number);
				}
			});
			
			// グラフアニメーション
			$this.find('.graph-img').each(function() {
				const $graph = $(this);
				if (!$graph.hasClass('animated')) {
					// console.log('初期実行: グラフ');
					$graph.addClass('animated');
					animateGraph($graph);
				}
			});
		});
		
		// 今後付与される要素用のMutationObserver
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === 'class') {
					const $target = $(mutation.target);
					if ($target.hasClass('animate__animated')) {
						
						// カウントアップ
						$target.find('.number').each(function() {
							const $number = $(this);
							if (!$number.hasClass('counted')) {
								console.log('スクロールで実行: カウント');
								$number.addClass('counted');
								countUpNumber($number);
							}
						});
						
						// グラフアニメーション
						$target.find('.graph-img').each(function() {
							const $graph = $(this);
							if (!$graph.hasClass('animated')) {
								console.log('スクロールで実行: グラフ');
								$graph.addClass('animated');
								animateGraph($graph);
							}
						});
					}
				}
			});
		});
		
		$('.animate').each(function() {
			observer.observe(this, { attributes: true });
		});
	});

	// ループテキストの画像読み込み待機
	const loopTexts = document.querySelectorAll('.loop-txt');

	loopTexts.forEach(loopTxt => {
		const images = loopTxt.querySelectorAll('img');
		
		Promise.all(
			Array.from(images).map(img => {
				if (img.complete) return Promise.resolve();
				return new Promise(resolve => {
					img.addEventListener('load', resolve);
					img.addEventListener('error', resolve);
				});
			})
		).then(() => {
			loopTxt.classList.add('loaded');
		});
	});

});